export function formatImperialLength(feet: number, inches: number) {
  return `${feet}′${inches ? ` ${inches}″` : ''}`;
}
